import { Injectable } from '@angular/core';
import _ from 'lodash';
import { environment } from 'environments/environment';
import { APP_SETTINGS } from '../settings';
import notify from 'devextreme/ui/notify';

declare function require(moduleName: string): any;
const { version: appVersion } = require('../../../package.json');

@Injectable()
export class AppInformationService {
    config: any;
    clientVersion: string;
    serviceVersion;
    versionWarning;
    applicationInfo: any;
    serviceName = environment.serviceName;
    isLoggedIn = false;
    title: string;
    pleaseWait = false;
    salesTaxRate = 0.06;
    achLinkBaseUrl = 'https://genesistrailers.azurewebsites.net/portal/dealer-ach/';
    featureFlags: { dealerDeliveryConfirmationEnabled: boolean } = {
        dealerDeliveryConfirmationEnabled: false,
    };

    private initVersionCheckEvent = new Event('initVersionCheck');
    private toastCount = 0;

    constructor() {
        this.clientVersion = appVersion;

        document.addEventListener('setAppInfoServiceVersion', (args: any) => {
            if (args && args.detail && args.detail.serviceVersion) {
                this.serviceVersion = args.detail.serviceVersion;
                document.dispatchEvent(this.initVersionCheckEvent);
            }
        });
    }

    get settings() {
        return APP_SETTINGS;
    }

    async pleaseWaitShow() {
        await Promise.resolve(null);
        this.pleaseWait = true;
    }

    async pleaseWaitHide() {
        await Promise.resolve(null);
        this.pleaseWait = false;
    }

    getDealerDeliveryConfirmationEnabled() {
        return this.featureFlags.dealerDeliveryConfirmationEnabled;
    }

    notifyToast(
        message: string,
        type: 'info' | 'warning' | 'error' | 'success' = 'success',
        displayTime = 5000,
        position = { my: 'center top', at: 'center top', offset: '0 20', of: 'body' },
    ) {
        notify({
            position,
            // position: { my: 'center top', at: 'right bottom', offset: '0 0', of: '.page-main' },
            message,
            closeOnClick: true,
            displayTime,
            width: '300px',
            type,
        });
    }

    notifyToastStack(
        message: string,
        type: 'info' | 'warning' | 'error' | 'success' = 'success',
        displayTime = 5000,
        position = { my: 'center top', at: 'center top', offset: '0 20', of: 'body' },
    ) {
        const offsetY = 10 + this.toastCount * 60; // Stack toasts 80px apart
        this.toastCount++;

        const notification = notify({
            position: { my: 'center top', at: 'center top', offset: `0 ${offsetY}`, of: 'body' },
            message,
            closeOnClick: true,
            displayTime,
            width: '500px',
            type,
            onHidden: () => {
                this.toastCount = Math.max(0, this.toastCount - 1);
            },
        });

        // Auto-decrement after displayTime
        setTimeout(() => {
            this.toastCount = Math.max(0, this.toastCount - 1);
        }, displayTime);
    }
}
